import BaseText from '@components/typography/BaseText';

/** The small capitals label that heads each right-panel state. */
const PanelEyebrow = ({ children, ...rest }) => (
	<BaseText size="xs" strong {...rest}>
		{children}
	</BaseText>
);

export default PanelEyebrow;
